import Selectline from "../ngn-file/select-line";
import { useState } from "react";
import useAppNavigate from "../../components/router/use-app-navigate";
import ShopLayout from "../../components/signup/shop-layout";

export default function NgnShopSelectline() {
  const [number, setNumber] = useState("");
  const navigate = useAppNavigate();

  function handleClick(productId: number, title: string) {
    setNumber(title);
    console.log("Selected NGN number:", title);

    navigate("/shop/purchase", {
      state: {
        selectedType: 40,
        ngnNumber: title,
      },
    });
  }

  return (
    <ShopLayout step={1} type={40} steps={[1, 2, 3]}>
      <Selectline onSelectLine={setNumber} handleClick={handleClick} />
    </ShopLayout>
  );
}
